<template>
  <task-tree>
    <transition name='fade' mode='out-in'>
      <fast-template v-if="showTemplate" @click="handleClickTemplate"/>
      <fast-template-detail v-else
        :templateId="templateId"
        :modelType="modelType"
        @click="showTemplate = true"/>
    </transition>
  </task-tree>
</template>
<script>
import TaskTree from './TaskTree'
import FastTemplate from './FastTemplate'
import FastTemplateDetail from './FastTemplateDetail'
export default {
  name: 'interactCollectCreateFast',
  components: {
    TaskTree,
    FastTemplate,
    FastTemplateDetail
  },
  data () {
    return {
      showTemplate: true,
      templateId: '',
      modelType: ''
    }
  },
  methods: {
    handleClickTemplate (item) {
      this.templateId = item.id
      this.modelType = item.modelType
      this.showTemplate = false
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
